// extracted by mini-css-extract-plugin
module.exports = {"containerOptionsCatalogue":"styles_containerOptionsCatalogue__3s9_n"};